<template>
  <!-- Parent Modal Component -->
  <Modal
    :title="$t('create_sub_category')"
    modalId="create-modal3"
    @submit="submitSubCategory"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitSubCategory">
      <!-- Category Select -->
      <div class="mb-3">
        <label class="form-label text-nowrap gap-2">{{ $t('select_category') }} <span class="text-danger">*</span></label>
        <div class="row justify-content-between align-items-center">
          <div class="col-12">
            
            <select  class="form-control" v-model="sub_category.p_id" disabled>
              <option v-if="categoryData" :value="categoryData.account_id">{{ this.categoryData.node }}</option>
            </select>
            <div v-if="errors.p_id" class="text-danger mt-2">
              <span>{{ errors.p_id }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Sub Category Name Input -->
      <div class="mb-3">
        <label class="form-label">{{ $t('sub_category_name') }} <span class="text-danger">*</span></label>
        <input
          type="text"
          v-model="sub_category.node"
          class="form-control"
          :placeholder="$t('enter_sub_category_name')"
        />
        <div v-if="errors.node" class="text-danger mt-2">
          <span>{{ errors.node }}</span>
        </div>
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls'; // Import API URLs

export default {
  components: {
    Modal,
  },

  props: {
    category: [Number, String], // Accepts an array OR a single ID
  },
  emits: ['create_success'], // Declare the custom event
  data() {
    return {
      sub_category: {
        node: '', // Sub category name
        p_id: '', // Parent category ID
      },
      errorMessage: '', // General error message
      errors: {}, // Field-specific errors
      categoryData: {}
    };
  },

  watch: {
    // Watch for changes in the category prop (the parent ID)
    category: {
      immediate: false, // Trigger immediately when the component is created
      handler(newCategory) {
        if (newCategory) {
          this.fetchCategoryDetails(newCategory); // Fetch category details by ID
        } else {
          this.categoryData = {}; // If no category ID is provided, reset categoryData
        }
      },
    },
  },


  methods: {
    // fetch Category Details
    async fetchCategoryDetails(category) {
      try {
        const response = await this.$axios.get(`${apiUrls.categories.get}${category}/`);
        this.categoryData = response.data; // Reset categoryData as an array

        // Ensure data is added to categoryData as an array
        this.sub_category.p_id = this.categoryData.account_id
      } catch (error) {
        console.error("Error fetching category:", error);
        this.categoryData = {}; // Handle error and reset data
      }
    },

    // Submit the subcategory form
    async submitSubCategory() {
      try {
        const formData = new FormData();
        Object.keys(this.sub_category).forEach((key) => {
          formData.append(key, this.sub_category[key]);
        });

        const response = await this.$axios.post(apiUrls.sub_categories.post, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        const modal = document.getElementById('create-modal3');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();
        // Emit event to update the parent component
        this.$emit('create_success',this.categoryData.id, response.data.id);

        this.$emit('create_success');
        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },

    // Reset the form and errors
    resetForm() {
      this.sub_category.node = '';
      this.sub_category.p_id = '';
      this.errors = {};
      this.errorMessage = '';
      this.categoryData = {};
    },
  },
};
</script>

<style scoped>
/* Add custom styles if needed */
</style>
